import React from "react";
import { Link } from "react-router-dom";
import "./SiteDisclaimer.css";

const SiteDisclaimer = ({ variant = "bar", compact = false }) => {
  return (
    <aside className={`disc-bar ${compact ? "disc-bar--compact" : ""}`}>
      <p>
        We are an independent third-party service provider and are not affiliated
        with the brands listed unless explicitly stated. U.S.-focused transparency
        and platform policy standards apply. Vendor terms apply.{" "}
        <Link to="/terms-and-conditions">Terms</Link> ·{" "}
        <Link to="/privacy-policy">Privacy</Link> ·{" "}
        <Link to="/refund-policy">Refund</Link>
      </p>
    </aside>
  );
};

export default SiteDisclaimer;
